import React, { FC } from 'react';
import { Table } from 'antd';

import { dynamicPagination } from '../../../../../utils/common/dynamicPagination';
import { getColumns } from '../utils/getColumns';
import { AttributesTableProps } from '../service/attributes.interface';

export const AttributesTable: FC<AttributesTableProps> = ({
    source,
    loading,
    filters,
    updateFilters,
    isBlocked,
}) => {
    return (
        <Table
            loading={loading || isBlocked}
            pagination={dynamicPagination(
                filters,
                updateFilters,
                source?.total,
                'Характеристик'
            )}
            dataSource={source?.items || []}
            rowKey={item => item.id}
            columns={getColumns(source?.total)}
        />
    );
};
